import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';
import { defaultLocale, locales } from './config';

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix: 'always', // Always include locale in URL
});

// Typed navigation helpers
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
